import {z} from 'zod';

import i18n from '@dms/i18n';

export const EmployeeCompetencesFormSchema = z.object({
  description: z
    .string({required_error: i18n.t('general.validations.fieldIsRequired')})
    .min(1, i18n.t('general.validations.fieldIsRequired')),
  isActive: z.boolean(),
});

export type EmployeeCompetencesForm = z.infer<typeof EmployeeCompetencesFormSchema>;
